/* =======================================================
   OGATU — MOTION (GLOBAL)
   1) Reveal system (single IntersectionObserver)
   2) Backwards compatible:
      - [data-reveal]  -> adds class "is-revealed"
      - [data-ogatu-reveal] -> adds class "ogatu-inview"
   3) Respects prefers-reduced-motion
   4) Works with Shopify Theme Editor
   5) Allows manual reveal trigger (for Hero slideshow state changes)
   ======================================================= */

(function () {
  const SELECTORS = {
    legacy: '[data-reveal]',
    v2:     '[data-ogatu-reveal]'
  };

  const CLASS = {
    legacy: 'is-revealed',
    v2:     'ogatu-inview'
  };

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealEl(el) {
    if (!el) return;

    if (el.matches(SELECTORS.legacy)) el.classList.add(CLASS.legacy);
    if (el.matches(SELECTORS.v2)) el.classList.add(CLASS.v2);
  }

  function resetEl(el) {
    if (!el) return;

    if (el.matches(SELECTORS.legacy)) el.classList.remove(CLASS.legacy);
    if (el.matches(SELECTORS.v2)) el.classList.remove(CLASS.v2);
  }

  function collectTargets(root) {
    const scope = root || document;
    const legacy = Array.from(scope.querySelectorAll(SELECTORS.legacy));
    const v2 = Array.from(scope.querySelectorAll(SELECTORS.v2));
    return legacy.concat(v2);
  }

  function revealAllNow(root) {
    collectTargets(root).forEach(revealEl);
  }

  let io = null;

  function ensureObserver() {
    if (io) return io;

    io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealEl(entry.target);
          io.unobserve(entry.target);
        });
      },
      { root: null, threshold: 0.12, rootMargin: '0px 0px -12% 0px' }
    );

    return io;
  }

  function mountReveal(root) {
    if (prefersReduced || !('IntersectionObserver' in window)) {
      revealAllNow(root);
      return;
    }

    const observer = ensureObserver();

    collectTargets(root).forEach((el) => {
      if (el.__ogatuObserved) return;
      el.__ogatuObserved = true;
      observer.observe(el);
    });
  }

  function unmountReveal(root) {
    if (!io) return;

    collectTargets(root).forEach((el) => {
      try { io.unobserve(el); } catch (e) {}
      delete el.__ogatuObserved;
    });
  }

  /* =======================================================
     NEW: Manual Reveal API (for slideshow state changes)
     ======================================================= */

  window.OgatuMotion = window.OgatuMotion || {};

  window.OgatuMotion.reveal = function (root) {
    if (!root) return;

    const targets = collectTargets(root);

    targets.forEach((el) => {
      resetEl(el);

      // force reflow so animation can restart
      void el.offsetWidth;

      revealEl(el);
    });
  };

  /* =======================================================
     Mount on load
     ======================================================= */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountReveal(document));
  } else {
    mountReveal(document);
  }

  document.addEventListener('shopify:section:load', (e) => {
    mountReveal(e.target);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    unmountReveal(e.target);
  });

})();